var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[(_vm.lastAccessTime)?_c('span',[_vm._v(_vm._s(_vm.timePeriodText))]):_c('span',[_vm._v("Not Recorded Yet")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }